import type { BeforeSendEvent } from "@vercel/analytics/react";
import { isAdminSubdomain } from "@/utils/admin/adminSubdomain";

/** `/admin` and everything under it: the operator console, not the product. */
export function isAdminPath(pathname: string): boolean {
  return pathname === "/admin" || pathname.startsWith("/admin/");
}

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "[::1]"]);

/**
 * Whether to load Vercel Analytics at all on this host. Not locally, and not
 * on the admin subdomain (admin.wildnetwork.app), which only the team uses.
 */
export function shouldLoadAnalytics(hostname: string): boolean {
  if (LOCAL_HOSTS.has(hostname) || hostname.endsWith(".local")) return false;
  return !isAdminSubdomain(hostname);
}

/**
 * `beforeSend` for <Analytics />: drop pageviews and events from admin pages,
 * so our own visits stay out of the numbers. The app is a single page, so the
 * script stays loaded when someone navigates from the site into /admin; this
 * is what keeps those views out.
 */
export function dropAdminTraffic(event: BeforeSendEvent): BeforeSendEvent | null {
  try {
    const url = new URL(event.url);
    if (isAdminSubdomain(url.hostname) || isAdminPath(url.pathname)) return null;
  } catch {
    // Unparseable URL: keep the event rather than guess.
  }
  return event;
}
